module.exports = __webpack_public_path__ + "static/media/githubIcon.aed478d6.svg";